class productsSwiperMobile extends HTMLElement {
  constructor() {
    super();
    this.swiper = this.querySelector(".products-swiper-mobile");
    this.slidesPerView = parseFloat(this.swiper.dataset.slidesPerView);
    console.log("this.slidesPerView: ", this.slidesPerView);
  }

  connectedCallback() {
    // Initialize Swiper
    this.initializeSwiper();
  }

  initializeSwiper() {
    this.swiper = new Swiper(this.swiper, {
      direction: "horizontal",
      pagination: {
        el: this.querySelector(".products-swiper-mobile__pagination"),
        clickable: true,
      },
      centeredSlides: true,
      spaceBetween: 20,
      cssMode: true,
      breakpoints: {
        // Disable Swiper above 768px
        769: {
          enabled: false,
        },
        // Enable Swiper below 769px
        0: {
          enabled: true,
          slidesPerView: this.slidesPerView,
        },
      },
    });
  }
}

// Define the custom element
customElements.define("products-swiper-mobile", productsSwiperMobile);
